import { Menu as MenuComponent } from './Menu';
import { MenuItem } from './MenuItem';

export const Menu = Object.assign(MenuComponent, {
    Item: MenuItem,
});
